














import Vue, { PropType } from "vue";
import ProjectHeaderT from "@/views/project/teacher/ProjectHeaderT.vue";
import { NavigationGuardNext, Route } from "vue-router";
import { AppStateStore } from "@/store/AppStateStore";
import { ProjectStore } from "@/store/ProjectStore";
import { Quarter } from "@/ts/objects/common/Quarter";
import { DataSlotState } from "@/ts/DataSlot";
import log from "loglevel";
import { ProjectInfoOnEditStore } from "@/store/ProjectInfoOnEditStore";
import { ProjectRepository } from "@/ts/repositories/ProjectRepository";

export default Vue.extend({
  name: "ProjectT",
  components: { ProjectHeaderT },
  props: {
    appStateStore: { type: Object as PropType<AppStateStore>, required: true },
    projectStore: { type: Object as PropType<ProjectStore>, required: true },
    projectInfoOnEditStore: { type: Object as PropType<ProjectInfoOnEditStore>, required: true },
    projectRepository: { type: Object as PropType<ProjectRepository>, required: true },
  },
  created() {
    log.debug(`ProjectT:created`);

    const classId = this.appStateStore.teacherState?.selectedClass()?.id ?? null;
    if (classId === null) return;

    const projectSchoolYearParam = this.$route.params["projectSchoolYear"];
    const projectQuarterParam = this.$route.params["projectQuarter"];
    this.projectStore.setQuarter(new Quarter(parseInt(projectSchoolYearParam, 10), parseInt(projectQuarterParam, 10)));

    const projectIdParam = this.$route.params["projectId"];
    this.projectStore.setProjectId(projectIdParam);

    this.projectStore.reloadProjects({ projectRepository: this.projectRepository, classIds: [classId] });
  },
  async beforeRouteUpdate(to: Route, from: Route, next: NavigationGuardNext) {
    log.debug(`ProjectT:beforeRouteUpdate`);

    const projectSchoolYearParam = to.params["projectSchoolYear"];
    const projectQuarterParam = to.params["projectQuarter"];
    this.projectStore.setQuarter(new Quarter(parseInt(projectSchoolYearParam, 10), parseInt(projectQuarterParam, 10)));

    const projectIdParam = to.params["projectId"];

    if (projectIdParam === "init") {
      const firstProjectId = await this.projectStore.firstProjectIdOfQuarter.getDataWithTimeout();
      this.projectStore.setProjectId(firstProjectId);
      next(this.projectStore.teacherBasePath);
    } else {
      this.projectStore.setProjectId(projectIdParam);
      next();
    }
  },
  computed: {
    projectStoreDataSlotState(): DataSlotState {
      return this.projectStore.allProjects.state;
    },
    projectRname(): string {
      return this.projectStore.project.data?.self ?? "";
    },
  },
  watch: {
    async projectStoreDataSlotState(newValue: DataSlotState, oldValue: DataSlotState) {
      // プロジェクトリストのロードが終わったとき、プロジェクト未選択状態なら、1個目のプロジェクトを選択して、そのパスに遷移する。
      // ※ initに遷移すれば beforeRouteUpdate が拾ってくれるかと思いきや、パスが全く変化しない場合は発火しないので、うまく働かない。ので、この方式。
      const currentlySelectedProject = await this.projectStore.project.getDataWithTimeout();
      const firstProjectId = await this.projectStore.firstProjectIdOfQuarter.getDataWithTimeout();
      log.debug(`watch:projectStoreDataSlotState: firstProjectId=${firstProjectId}`);
      if (
        oldValue === DataSlotState.Loading &&
        newValue === DataSlotState.DataLoaded &&
        currentlySelectedProject === null &&
        firstProjectId !== null
      ) {
        this.projectStore.setProjectId(firstProjectId);
        this.$router.push(this.projectStore.teacherBasePath).catch(() => {});
      }
    },
  },
});
